var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.873,
    height: 63.296,
    viewBox: "0 0 48.873 63.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash_Admin_",
    "data-name": "Trash (Admin)",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M207.988,319.375a1.371,1.371,0,0,0-1.367,1.367v16.678a1.367,1.367,0,1,0,2.734,0V320.742A1.371,1.371,0,0,0,207.988,319.375Zm0,0",
    transform: "translate(-183.559 -284.446)",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M287.988,319.375a1.371,1.371,0,0,0-1.367,1.367v16.678a1.367,1.367,0,1,0,2.734,0V320.742A1.371,1.371,0,0,0,287.988,319.375Zm0,0",
    transform: "translate(-254.809 -284.446)",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M127.988,319.375a1.371,1.371,0,0,0-1.367,1.367v16.678a1.367,1.367,0,1,0,2.734,0V320.742A1.371,1.371,0,0,0,127.988,319.375Zm0,0",
    transform: "translate(-112.307 -284.446)",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M38.444,7H30.625V3.021A3.023,3.023,0,0,0,27.6,0H12.757A3.022,3.022,0,0,0,9.735,3.021V7.013H1.916A6.166,6.166,0,0,0-.108,19a1.153,1.153,0,0,0-.041.3V56.461A6.838,6.838,0,0,0,6.687,63.3h27a6.838,6.838,0,0,0,6.835-6.835V19.3a1.039,1.039,0,0,0-.041-.3A6.173,6.173,0,0,0,38.444,7ZM12.484,3.021a.288.288,0,0,1,.287-.287H27.617a.288.288,0,0,1,.287.287V7.013H12.484Zm21.19,57.541H6.687a4.114,4.114,0,0,1-4.1-4.1V19.344h35.2V56.461A4.125,4.125,0,0,1,33.674,60.562ZM38.444,16.61H1.916a3.431,3.431,0,1,1,0-6.863H38.444a3.431,3.431,0,1,1,0,6.863Zm0,0",
    transform: "translate(4.25)",
    fill: "#009639"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteVector);
export default __webpack_public_path__ + "static/media/DeleteVector.564ae0df37ae992619b35d52a59e66e6.svg";
export { ForwardRef as ReactComponent };